import React from "react";
import { useInView } from '../hooks/useInView';
import '@fortawesome/free-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faJava, faPython, faJs, faReact, faNode, faGitAlt, faGithub, faAws } from '@fortawesome/free-brands-svg-icons';
import '../assets/styles/Skills.scss';

function Skills() {
    const { ref, inView } = useInView({ threshold: 0.1 });
    
    return (
        <div ref={ref} id="skills" className={`skills-section skills-container section-fade ${inView ? 'in-view' : ''}`}>
            <div className="items-container">
                <h1>Technical Skills</h1>
                
                <div className="skills-category">
                    <h3>Programming Languages</h3>
                    <div className="skills-grid">
                        <div className="skill-item">
                            <FontAwesomeIcon icon={faJava} className="skill-logo"/>
                            <p>Java</p>
                        </div>
                        <div className="skill-item">
                            <FontAwesomeIcon icon={faPython} className="skill-logo"/>
                            <p>Python</p>
                        </div>
                        <div className="skill-item">
                            <FontAwesomeIcon icon={faJs} className="skill-logo"/>
                            <p>JavaScript</p>
                        </div>
                        <div className="skill-item">
                            <div className="skill-logo-text">SQL</div>
                            <p>SQL</p>
                        </div>
                        <div className="skill-item">
                            <div className="skill-logo-text">HTML</div>
                            <p>HTML</p>
                        </div>
                        <div className="skill-item">
                            <div className="skill-logo-text">CSS</div>
                            <p>CSS</p>
                        </div>
                    </div>
                </div>

                <div className="skills-category">
                    <h3>Frameworks & Technologies</h3>
                    <div className="skills-grid">
                        <div className="skill-item">
                            <FontAwesomeIcon icon={faReact} className="skill-logo"/>
                            <p>React.js</p>
                        </div>
                        <div className="skill-item">
                            <FontAwesomeIcon icon={faNode} className="skill-logo"/>
                            <p>Node.js</p>
                        </div>
                        <div className="skill-item">
                            <div className="skill-logo-text">Next</div>
                            <p>Next.js</p>
                        </div>
                        <div className="skill-item">
                            <div className="skill-logo-text">Flask</div>
                            <p>Flask</p>
                        </div>
                        <div className="skill-item">
                            <div className="skill-logo-text">FastAPI</div>
                            <p>FastAPI</p>
                        </div>
                        <div className="skill-item">
                            <div className="skill-logo-text">WP</div>
                            <p>WordPress</p>
                        </div>
                    </div>
                </div>

                <div className="skills-category">
                    <h3>Libraries & Tools</h3>
                    <div className="skills-grid">
                        <div className="skill-item">
                            <div className="skill-logo-text">Pandas</div>
                            <p>Pandas</p>
                        </div>
                        <div className="skill-item">
                            <div className="skill-logo-text">NumPy</div>
                            <p>NumPy</p>
                        </div>
                        <div className="skill-item">
                            <div className="skill-logo-text">Matplotlib</div>
                            <p>Matplotlib</p>
                        </div>
                        <div className="skill-item">
                            <FontAwesomeIcon icon={faGitAlt} className="skill-logo"/>
                            <p>Git</p>
                        </div>
                        <div className="skill-item">
                            <FontAwesomeIcon icon={faGithub} className="skill-logo"/>
                            <p>GitHub</p>
                        </div>
                        <div className="skill-item">
                            <div className="skill-logo-text">VS</div>
                            <p>VS Code</p>
                        </div>
                        <div className="skill-item">
                            <div className="skill-logo-text">IDEA</div>
                            <p>IntelliJ</p>
                        </div>
                        <div className="skill-item">
                            <div className="skill-logo-text">PyCharm</div>
                            <p>PyCharm</p>
                        </div>
                    </div>
                </div>

                <div className="skills-category">
                    <h3>Cloud & Deployment</h3>
                    <div className="skills-grid">
                        <div className="skill-item">
                            <div className="skill-logo-text">Azure</div>
                            <p>Azure</p>
                        </div>
                        <div className="skill-item">
                            <div className="skill-logo-text">GCP</div>
                            <p>Google Cloud</p>
                        </div>
                        <div className="skill-item">
                            <FontAwesomeIcon icon={faAws} className="skill-logo"/>
                            <p>AWS</p>
                        </div>
                        <div className="skill-item">
                            <div className="skill-logo-text">Vercel</div>
                            <p>Vercel</p>
                        </div>
                        <div className="skill-item">
                            <div className="skill-logo-text">Heroku</div>
                            <p>Heroku</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Skills;
